import React, { useMemo } from 'react';

function NotificationPanel({ open, onClose, notifications, unreadCount = 0 }) {
  // Sort notifications by urgency or time (mock logic: existing order serves well)
  const sortedNotifs = useMemo(() => notifications, [notifications]);

  return (
    <>
      <div
        className={`notif-overlay-glass ${open ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside className={`notif-panel-glass ${open ? 'open' : ''}`} aria-label="Notificaciones">
        <header className="notif-header-glass">
          <div>
            <h2 className="notif-header-title">Novedades</h2>
            {unreadCount > 0 && <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{unreadCount} nuevas</span>}
          </div>
          <button className="notif-mark-read" onClick={() => alert("Todas leídas (Demo)")}>
            Marcar leídas
          </button>
        </header>

        <div className="notif-list-scroll">
          {sortedNotifs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>
              <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.5rem' }}>💤</span>
              Todo tranquilo por aquí.
            </div>
          ) : (
            sortedNotifs.map((notif) => (
              <div key={notif.id} className={`notif-card ${notif.tone === 'urgent' ? 'urgent' : ''}`}>
                <div className="notif-icon-box">
                  {notif.icon || (notif.tone === 'urgent' ? '⚠️' : '📢')}
                </div>
                <div className="notif-card-content">
                  <h3 className="notif-card-title">{notif.title}</h3>
                  <p className="notif-card-desc">{notif.description}</p>
                  <span className="notif-time">{notif.timeAgo}</span>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer Action (Optional) */}
        <div style={{ padding: '1rem', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
          <button className="pill-button pill-button-ghost" style={{ width: '100%' }} onClick={onClose}>
            Cerrar panel
          </button>
        </div>
      </aside>
    </>
  );
}

export default NotificationPanel;
